import { commonActionType, paymentInitActionType } from '../../actionTypes';
import paymentInitAction from './actionType';
import getTransactionInfo from './getTransactionInfo';
import { tracker } from '../../tracking';
import onTransactionErrorBlock from '../onTransactionErrorBlock';
import getPosTransactionInfo from './getPosTransactionInfo';

export default (actionType, ...args) => (dispatch, getState) => {
  switch (actionType) {
    case paymentInitAction.initialize:
      const data = args[0];
      const { utmCampaign, txnUuid, sourceRef, channel } = data || {};
      dispatch({
        type: commonActionType.INIT_QUERY,
        payload: {
          utmCampaign,
          txnUuid,
          sourceRef,
          shouldShowHeader: false,
          shouldShowDrawer: false,
        },
      });
      if (channel === 'OFFLINE' && !sourceRef)
        return dispatch(getPosTransactionInfo({ txnUuid }));
      else return dispatch(getTransactionInfo({ txnUuid, sourceRef }));
    case paymentInitAction.onLenderTypeSelection:
      const argsData = args[0];
      const { selectedLenderType } = argsData;
      return dispatch({
        type: paymentInitActionType.UPDATE_TRANSACTION_LENDER_TYPE,
        payload: {
          selectedLenderType
        }
      });
    case paymentInitAction.onTransactionTimeOut:
      const { config, modal } = getState() || {};
      const { pageKey } = config || {};
      const { errorBlockTransaction } = modal || {};
      const {
        cta,
        errorType,
        helpText,
        title,
        message = 'Transaction has exceeded the time limit and has been canceled.',
      } = errorBlockTransaction || {};
      tracker.trackApplicationError(
        'Transaction Timeout',
        pageKey || 'Missing pageKey',
      );
      dispatch({
        type: paymentInitActionType.TRANSACTION_TIMEOUT_ERROR_MESSAGE,
        payload: {
          errorMessage: message,
        },
      });
      return dispatch(
        onTransactionErrorBlock({ cta, errorType, helpText, title, message }),
      );
    default:
      return console.error(`missing handle for actionType: ${actionType}`);
  }
};



// WEBPACK FOOTER //
// ./components/transaction/src/actions/onPaymentInit/index.js